import { TableNames } from '~/constants';
import idb from '~/stores/providers/Idb';
import { userStore } from '~/stores/UserStore';
import { isEmpty } from 'lodash';
import { curry } from 'ramda';

import crypto from '../providers/Crypto';

class DraftLogActions {
  get userId() {
    return userStore.id;
  }

  private getKey = (channelId: string) => {
    return `${channelId}:${this.userId}`;
  };

  private encryptText = (text: string) => {
    return crypto.encrypt(this.userId, text);
  };

  private decryptLogText = (text: string) => {
    return crypto.decrypt(this.userId, text);
  };

  get = async (channelId: string): Promise<string> => {
    const key = this.getKey(channelId);
    const value: string = (await idb.get(TableNames.DraftLogs, key)) as string;
    return isEmpty(value) ? '' : this.decryptLogText(value);
  };

  delete = (channelId: string) => {
    idb.delete(TableNames.DraftLogs, this.getKey(channelId));
  };

  set = curry(async (channelId: string, value: string) => {
    if (isEmpty(value)) {
      this.delete(channelId);
      return;
    }
    if (await this.get(channelId)) {
      idb.put(TableNames.DraftLogs, this.getKey(channelId), this.encryptText(value));
    } else {
      idb.add(TableNames.DraftLogs, this.getKey(channelId), this.encryptText(value));
    }
  });
}

export default DraftLogActions;
